import * as d3 from 'd3';
import { chartSm, chartXs } from '../constants';

export class SymbolScaleHelper {
    private static symbolScaler = d3.scale.linear<number, number>()
        .range([0.2, 0.5])
        .domain([200*60, 520*240]) //Scaling based on chart area
        .clamp(true);

    static scale(xScale, yScale): number {
        const area = xScale.range()[1] * yScale.range()[0];
        return SymbolScaleHelper.symbolScaler(area);
    }
}